module.exports = __webpack_public_path__ + "static/media/sq_lion.f5abd800.png";